module.exports = __webpack_public_path__ + "img/nodata2.f4b4480e.svg";